import Bowser from 'bowser';

export const isNextServer = () => typeof window === 'undefined';
export const isNextClient = () => typeof window !== 'undefined';

export const uaParse = (ua: string = '') => {
  if (!ua) {
    ua = getUAString();
  }
  let result: Bowser.Parser.ParsedResult = {
    browser: { name: '', version: '' },
    os: {},
    platform: {},
    engine: {},
  };
  if (ua) {
    result = Bowser.parse(ua);
  }
  const isInJoybuyApp = ua?.includes('kaappschema=openapp.jdiapp;');
  const isInOchamaApp = ua?.indexOf('MCA/') >= 0;
  // 判断是否在安卓端
  const isAndroid = result.os.name === 'Android';
  // 判断是否在iOS端
  const isIOS = result.os.name === 'iOS';

  const isPC =
    !isAndroid &&
    !isIOS &&
    (result.platform.type === 'desktop' ||
      ['Windows', 'macOS', 'Linux', 'Chrome OS'].includes(result.os.name || ''));

  return {
    ...result,
    isInJoybuyApp,
    isInOchamaApp,
    isAndroid,
    isIOS,
    isPC,
  };
};

export const getUAString = () => {
  if (isNextClient()) {
    return window.navigator.userAgent;
  } else {
    const { headers } = require('next/headers');
    const headersList = headers();
    return headersList.get('user-agent');
  }
};

export const getPageUrl = () => {
  try {
    if (isNextClient()) {
      // 客户端 - 使用 window.location
      return window?.location?.href;
    }
    // 服务端
    const { headers: nextHeaders } = require('next/headers');

    const headersList = nextHeaders();

    const protocol = headersList.get('x-forwarded-proto') || 'https';
    const host = headersList.get('host');
    const pathname = headersList.get('pathname') || '/';
    return `${protocol}://${host}${pathname}`;
  } catch (e) {
    return null;
  }
};
